'use strict';
import * as $j_app$002edata$002e$002dApp$002dRegistered$002dUser from "./app.data.-App-Registered-User.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_AppRegisteredUser$GeneralPracticeUser$() {
}
export { $c_Lapp_data_AppRegisteredUser$GeneralPracticeUser$ as $c_Lapp_data_AppRegisteredUser$GeneralPracticeUser$ };
$c_Lapp_data_AppRegisteredUser$GeneralPracticeUser$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_AppRegisteredUser$GeneralPracticeUser$.prototype.constructor = $c_Lapp_data_AppRegisteredUser$GeneralPracticeUser$;
/** @constructor */
function $h_Lapp_data_AppRegisteredUser$GeneralPracticeUser$() {
}
export { $h_Lapp_data_AppRegisteredUser$GeneralPracticeUser$ as $h_Lapp_data_AppRegisteredUser$GeneralPracticeUser$ };
$h_Lapp_data_AppRegisteredUser$GeneralPracticeUser$.prototype = $c_Lapp_data_AppRegisteredUser$GeneralPracticeUser$.prototype;
$c_Lapp_data_AppRegisteredUser$GeneralPracticeUser$.prototype.toString__T = (function() {
  return "GeneralPracticeUser";
});
$c_Lapp_data_AppRegisteredUser$GeneralPracticeUser$.prototype.fromProduct__s_Product__Lapp_data_AppRegisteredUser$GeneralPracticeUser = (function(x$0) {
  var userId$1 = x$0.productElement__I__O(0);
  var name$1 = x$0.productElement__I__O(1);
  var phone$1 = x$0.productElement__I__O(2);
  var practices$1 = x$0.productElement__I__O(3);
  var isAdmin$1 = (!(!x$0.productElement__I__O(4)));
  var settings$1 = x$0.productElement__I__O(5);
  return new $j_app$002edata$002e$002dApp$002dRegistered$002dUser.$c_Lapp_data_AppRegisteredUser$GeneralPracticeUser(userId$1, name$1, phone$1, practices$1, isAdmin$1, settings$1);
});
$c_Lapp_data_AppRegisteredUser$GeneralPracticeUser$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lapp_data_AppRegisteredUser$GeneralPracticeUser(p);
});
var $d_Lapp_data_AppRegisteredUser$GeneralPracticeUser$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_AppRegisteredUser$GeneralPracticeUser$, "app.data.AppRegisteredUser$GeneralPracticeUser$", ({
  Lapp_data_AppRegisteredUser$GeneralPracticeUser$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lapp_data_AppRegisteredUser$GeneralPracticeUser$ as $d_Lapp_data_AppRegisteredUser$GeneralPracticeUser$ };
var $n_Lapp_data_AppRegisteredUser$GeneralPracticeUser$;
function $m_Lapp_data_AppRegisteredUser$GeneralPracticeUser$() {
  if ((!$n_Lapp_data_AppRegisteredUser$GeneralPracticeUser$)) {
    $n_Lapp_data_AppRegisteredUser$GeneralPracticeUser$ = new $c_Lapp_data_AppRegisteredUser$GeneralPracticeUser$();
  }
  return $n_Lapp_data_AppRegisteredUser$GeneralPracticeUser$;
}
export { $m_Lapp_data_AppRegisteredUser$GeneralPracticeUser$ as $m_Lapp_data_AppRegisteredUser$GeneralPracticeUser$ };
//# sourceMappingURL=app.data.-App-Registered-User$-General-Practice-User$.js.map
